export default [
	{
		key: 'group.name',
		title: 'Group',
		scopedSlots: {customRender: 'group'}
	}, {
		key: 'code',
		title: 'Code',
		scopedSlots: {customRender: 'code'}
	}, {
		key: 'denomination',
		title: 'Denomination',
		scopedSlots: {customRender: 'denomination'}
	}, {
		key: 'price',
		title: 'Price',
		scopedSlots: {customRender: 'price'}
	}, {
		key: 'price_scheme',
		title: 'Price Scheme',
		scopedSlots: {customRender: 'priceScheme'}
	}, {
		key: 'admin_fee',
		title: 'Admin Fee',
		scopedSlots: {customRender: 'adminFee'}
	}, {
		key: 'share_fee',
		title: 'Share Fee',
		scopedSlots: {customRender: 'shareFee'}
	}, {
		dataIndex: 'updated_at',
		key: 'updatedAt',
		title: 'Last Updated',
		scopedSlots: {customRender: 'updatedAt'}
	}, {
		key: 'state',
		title: "State",
		width: 100,
		align: 'center',
		scopedSlots: {customRender: 'state'}
	}, {
		key: 'action',
		title: '',
		align: 'right',
		width: 150,
		scopedSlots: {customRender: 'action'}
	}
]
